export const PREMERA_PEAK_CARE = 'PK';
export const PREMERA_AK = 'AK';
export const PREMERA_WA = 'WA';
export const FLORIDA_BLUE_RPM = 'FB_RPM';
export const FLORIDA_BLUE_OPD = 'FB_OPD';
